import type { PublicConsultationType } from './public-consultation-type';
import type { Specialist } from './specialist';

/**
 * The two anonymous lists the public pages need before anything else, in one object. Mirrors
 * `PublicSiteDataDTO`, which is what the API writes into the file nginx inlines into every page.
 */
export interface PublicSiteData {
    specialists: Specialist[];
    consultationTypes: PublicConsultationType[];
}

export const EMPTY_PUBLIC_SITE_DATA: PublicSiteData = { specialists: [], consultationTypes: [] };
